import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { importFile, useExportTemplateMutation } from 'services/category';
import { CookieStorage } from 'utils/cookie-storage';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { FileExcelValid, ModalType } from 'constants/common';
import SizeTable from './components/Table';
import CreateCategoryModal from './components/CreateCategoryModal';
import Pagination from 'components/Pagination/Pagination';
import { downloadFile } from 'utils/helpers';
import { toast } from 'components/Toast';
import { useUserState } from 'context/UserContext';
import { useQueryGetListBanner } from 'services/banner';
import PreviewBannerDialog from './components/PreviewBannerDialog';

function Banner() {
  const textColor = useColorModeValue('gray.700', 'white');
  const history = useHistory();
  const [sizeEditing, setSizeEditing] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const exportTemplateMutation = useExportTemplateMutation();
  const inputImportRef = useRef();

  useEffect(() => {
    if (!CookieStorage.isAuthenticated()) {
      return history.push('/auth/sign-in');
    }
  }, []);

  const { isOpen: isCreateModalOpen, onOpen: onOpenCreateModal, onClose: onCloseCreateModal } = useDisclosure();
  const { isOpen: isPreviewModalOpen, onOpen: onOpenPreviewModal, onClose: onClosePreviewModal } = useDisclosure();
  const { isOpen: isChangeStatusModalOpen, onOpen: onOpenChangeStatusModal, onClose: onCloseChangeStatusModal } = useDisclosure();
  const openModal = useMemo(
    () => ({
      [ModalType.Add]: onOpenCreateModal,
      [ModalType.ChangeStatus]: onOpenChangeStatusModal,
      [ModalType.Detail]: onOpenPreviewModal,
    }),
    [onOpenCreateModal, onOpenChangeStatusModal, onOpenPreviewModal]
  );
  const closeModal = useMemo(
    () => ({
      [ModalType.Add]: onCloseCreateModal,
      [ModalType.ChangeStatus]: onCloseChangeStatusModal,
      [ModalType.Detail]: onClosePreviewModal,
    }),
    [onCloseCreateModal, onCloseChangeStatusModal, onClosePreviewModal]
  );

  const { data: categoryData, refetch } = useQueryGetListBanner(
    { ...filter, searchKeyword: filter.searchTitle },
    { enabled: CookieStorage.isAuthenticated() }
  );

  const handleUpdateItem = (size, modalType) => {
    openModal?.[modalType]?.();
    setSizeEditing(size);
  };

  const handelCloseModal = modalType => {
    closeModal?.[modalType]?.();
    setSizeEditing(null);
  };

  const handleSearch = () => {
    setFilter({
      ...filter,
      searchTitle: searchTitle,
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setSearchTitle('');
  };

  const onDownloadTemplate = () => {
    exportTemplateMutation.mutate(undefined, {
      onSuccess: response => {
        downloadFile(response, 'category-template');
        toast.showMessageSuccess('Tải mẫu shortlink thành công');
      },
      onError: () => {
        toast.showMessageError('Tải mẫu shortlink thất bại');
      },
    });
  };

  const handleImportFileExcel = async e => {
    if (e?.target?.files?.[0]) {
      const file = e.target.files[0];
      const extensionFile = file?.name?.split('.')?.pop();

      if (FileExcelValid.includes(extensionFile)) {
        const formData = new FormData();

        formData.append('importFile', file);

        await importFile(formData)
          .then(() => {
            toast.showMessageSuccess('Tải lên danh sách shortlink thành công');
            refetch();
          })
          .catch(() => {
            toast.showMessageError('Tải lên danh sách shortlink thất bại');
          });

        return;
      }

      setError('Chỉ hỗ trợ tải lại file định dạng .xlsx, xls');
    }
  };

  const handleDeleteAllRecord = () => {
    if (window.confirm('Bạn có chắc chắn muốn xóa tất cả các shortlink?')) {
      // deleteCategoryMutation.mutate(
      //   { id: category?._id },
      //   {
      //     onSuccess: () => {
      //       toast.showMessageSuccess('Xóa tất cả các shortlink thành công');
      //       refetch?.();
      //     },
      //     onError: () => {
      //       toast.showMessageError('Xóa tất cả các shortlink không thành công');
      //       refetch?.();
      //     },
      //   }
      // );
    }
  };

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
      <Card p="16px" mb="24px" bg="#fff">
        <CardHeader p="12px 5px" mb="12px">
          <Flex justifyContent={'space-between'}>
            <Flex direction={'column'}>
              <Flex direction="column" gap={'30px'}>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  Danh sách banner
                </Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'} gap={'20px'} mt={'20px'}>
                <Stack>
                  <Flex alignItems={'center'} gap={'20px'} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                    <FormControl minWidth={{ base: 'full', sm: '300px' }}>
                      <FormLabel>Tìm kiếm</FormLabel>
                      <Input value={searchTitle} onChange={e => setSearchTitle(e.target.value)} />
                    </FormControl>
                    <Button maxH="40px" alignSelf={'end'} onClick={handleReset}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Cài lại
                      </Text>
                    </Button>
                    <Button variant="primary" maxH="40px" alignSelf={'end'} onClick={handleSearch}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Tìm kiếm
                      </Text>
                    </Button>
                  </Flex>
                </Stack>
              </Flex>
            </Flex>
            <Flex alignItems={'start'} gap={4}>
              {/* <Button bg="red.500" color="white" _hover={{ bg: 'red.400' }} onClick={handleDeleteAllRecord}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Xóa tất cả
                </Text>
              </Button> */}
              <Button bg="#3182ce" color="#fff" _hover={{ bg: '#67a1d7' }} onClick={onOpenCreateModal}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Thêm
                </Text>
              </Button>
              <Flex alignItems="center">
                <input type="file" hidden ref={inputImportRef} onChange={handleImportFileExcel} />
                <Button
                  bg="#3182ce"
                  color="#fff"
                  _hover={{ bg: '#67a1d7' }}
                  onClick={() => {
                    inputImportRef?.current?.click();
                  }}
                >
                  Import file excel
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody overflowX="auto">
          <Stack overflow={'auto'}>
            <SizeTable categoryData={categoryData?.data || []} handleUpdateCategory={handleUpdateItem} refetch={refetch} onOpenPreviewModal={onOpenPreviewModal}/>
          </Stack>
          <Flex justifyContent={'flex-end'}>
            <Pagination
              page={categoryData?.pagination?.page}
              pageLength={categoryData?.pagination?.pageSize}
              totalRecords={categoryData?.pagination?.count}
              onPageChange={(page, pageLength) => {
                setFilter({
                  ...filter,
                  pageSize: pageLength,
                  pageIndex: page - 1,
                });
              }}
            />
          </Flex>
        </CardBody>
      </Card>
      {isCreateModalOpen && (
        <CreateCategoryModal categorysDetail={sizeEditing} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} />
      )}
      {isPreviewModalOpen && (
        <PreviewBannerDialog banner={sizeEditing} isOpen={isPreviewModalOpen} onClose={handelCloseModal} refetch={refetch} />
      )}
    </Flex>
  );
}

export default Banner;
